<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/dailyWinLose")
          i.fa.fa-chart-line
          span.ml-1 {{ $t("ui.daily_winlose") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.icon-user
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getWinLose(true)")
                div.row.col-md-10
                  div(width="70%").mr-3
                    DateRangePicker(:value="dateRange" @update="getData")
                  div(width="30%")
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-search"
                      :text="$t('ui.search')"
                      type="button"
                      @click="getWinLose(true)"
                      variant="success"
                      size="sm"
                      ).mr-2
                    jsonToExcel(v-if="winloseList.length > 0" mode="DailyWinlose" tbl="tblList" :date="dateRange")
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.utmPageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex#tblList(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('turnover')")
                        span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                        i(:class="changeSortKey('turnover')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('valid_turnover')")
                        span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                        i(:class="changeSortKey('valid_turnover')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('winlose')")
                        span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                        i(:class="changeSortKey('winlose')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('bet_count')")
                        span(:title="$t('ui.bet_count')") {{ $t('ui.short.bet_count') }}
                        i(:class="changeSortKey('bet_count')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('deposit_amount')")
                        span(:title="$t('ui.deposit_amount')") {{ $t('ui.short.deposit_amount') }}
                        i(:class="changeSortKey('deposit_amount')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('deposit_count')")
                        span(:title="$t('ui.deposit_count')") {{ $t('ui.short.deposit_count') }}
                        i(:class="changeSortKey('deposit_count')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('withdrawal_amount')")
                        span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.short.withdrawal_amount") }}
                        i(:class="changeSortKey('withdrawal_amount')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('withdrawal_count')")
                        span(:title="$t('ui.withdrawal_count')") {{ $t('ui.short.withdrawal_count') }}
                        i(:class="changeSortKey('withdrawal_count')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('bonus_amount')")
                        span(:title="$t('ui.bonus_amount')") {{ $t("ui.short.bonus_amount") }}
                        i(:class="changeSortKey('bonus_amount')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('adjustment_amount')")
                        span(:title="$t('ui.adjustment_amount')") {{ $t("ui.short.adjustment_amount") }}
                        i(:class="changeSortKey('adjustment_amount')")
                      th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('referee_count')")
                        span(:title="$t('ui.referee_count')") {{ $t("ui.short.referee_count") }}
                        i(:class="changeSortKey('referee_count')")
                  tbody.clusterize-content
                    tr(v-if="winloseList.length == 0")
                      td(colspan="13").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in winloseList")
                      td
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span#accId(:title="item.account_id") {{ item.account_id }}&nbsp;
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                      td.text-right
                        //- span.font-weight-bold(v-if="item.winlose == 0" :class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                        //- span.font-weight-bold(v-if="item.winlose != 0")
                        //-   b-link(href="javascript:void(0);" @click="redirectToWL(item)" :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                        span.font-weight-bold(v-if="item.winlose != 0 && showActionButton('platformwinlose')")
                          b-link(href="javascript:void(0);" @click="redirectToWL(item)" :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                        span.font-weight-bold(v-else :class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:title="$n(item.bet_count, 'integer')") {{ $n(item.bet_count, 'integer') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:title="$n(item.deposit_count, 'integer')") {{ $n(item.deposit_count, 'integer') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.withdrawal_amount * -1)" :title="$n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:title="$n(item.withdrawal_count, 'integer')") {{ $n(item.withdrawal_count, 'integer') }}
                      td.text-right
                        span.font-weight-bold(v-if="item.bonus_amount == 0" :class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                        span.font-weight-bold(v-if="item.bonus_amount != 0")
                          b-link(href="javascript:void(0);" @click="redirectToBonus()" :class="$helpers.fontClassName(item.bonus_amount, true)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                      td.text-right
                        span.font-weight-bold
                          b-link(href="javascript:void(0);" @click="redirectToAdjustment()" :class="[item.adjustment_amount < 0 ? 'text-danger' : 'text-info']" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:title="$n(item.referee_count, 'integer')") {{ $n(item.referee_count, 'integer') }}
                    tr(v-if="showTotal")
                      td.text-right(colspan="2")
                        span {{ $t("ui.sub_total") }}
                        br
                        span {{ $t("ui.grand_total") }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalBetCount)" :title="$n(subTotalBetCount, 'integer')") {{ $n(subTotalBetCount, 'integer') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBetCount)" :title="$n(grandTotalBetCount, 'integer')") {{ $n(grandTotalBetCount, 'integer') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmount)" :title="$n(subTotalDepositAmount, 'currency')") {{ $n(subTotalDepositAmount, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmount)" :title="$n(grandTotalDepositAmount, 'currency')") {{ $n(grandTotalDepositAmount, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositCount)" :title="$n(subTotalDepositCount, 'integer')") {{ $n(subTotalDepositCount, 'integer') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositCount)" :title="$n(grandTotalDepositCount, 'integer')") {{ $n(grandTotalDepositCount, 'integer') }}
                      td.text-right
                        span.font-weight-bold(:class="[subTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency')") {{ $n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency') }}
                        br
                        span.font-weight-bold(:class="[grandTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency')") {{ $n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalWithdrawalCount)" :title="$n(subTotalWithdrawalCount, 'integer')") {{ $n(subTotalWithdrawalCount, 'integer') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawalCount)" :title="$n(grandTotalWithdrawalCount, 'integer')") {{ $n(grandTotalWithdrawalCount, 'integer') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmount)" :title="$n(subTotalBonusAmount, 'currency')") {{ $n(subTotalBonusAmount, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmount)" :title="$n(grandTotalBonusAmount, 'currency')") {{ $n(grandTotalBonusAmount, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalAdjustmentAmount)" :title="$n(subTotalAdjustmentAmount, 'currency')") {{ $n(subTotalAdjustmentAmount, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAdjustmentAmount)" :title="$n(grandTotalAdjustmentAmount, 'currency')") {{ $n(grandTotalAdjustmentAmount, 'currency') }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalRefereeCount)" :title="$n(subTotalRefereeCount, 'integer')") {{ $n(subTotalRefereeCount, 'integer') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRefereeCount)" :title="$n(grandTotalRefereeCount, 'integer')") {{ $n(grandTotalRefereeCount, 'integer') }}
                      td

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    grandTotalList: [],
    winloseList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalDepositAmount: 0,
    grandTotalDepositAmount: 0,
    subTotalWithdrawalAmount: 0,
    grandTotalWithdrawalAmount: 0,
    subTotalBonusAmount: 0,
    grandTotalBonusAmount: 0,
    subTotalAdjustmentAmount: 0,
    grandTotalAdjustmentAmount: 0,
    subTotalBetCount: 0,
    grandTotalBetCount: 0,
    subTotalRefereeCount: 0,
    grandTotalRefereeCount: 0,
    subTotalDepositCount: 0,
    grandTotalDepositCount: 0,
    subTotalWithdrawalCount: 0,
    grandTotalWithdrawalCount: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "working_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.utmPageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    if (this.$store.getters.dailyStatement.account_id != null)
      this.search = this.$store.getters.dailyStatement.account_id;

    if (this.$store.getters.dailyStatement.start_date && this.$store.getters.dailyStatement.end_date) {
      this.dateRange.startDate = this.$store.getters.dailyStatement.start_date;
      this.dateRange.endDate = this.$store.getters.dailyStatement.end_date;
    } else {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    }

    this.getWinLose(true);
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    redirectToWL: function(item) {
      var json = {
        account_id: item.account_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setWinLoseParam", json);
      this.$router.push("/report/platformWinLose");
    },
    redirectToAdjustment: function(item) {
      var json = {
        member_id: item.account_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.$store.dispatch("user/setAdjustmentListParam", json);
      this.$router.push("/report/adjustmentList");
    },
    redirectToBonus: function(item) {
      var json = {
        member_id: item.account_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.$store.dispatch("user/setBonusListParam", json);
      this.$router.push("/report/bonusList");
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getWinLose(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getWinLose(true);
    },
    getWinLose: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.dailyWinLoseUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          member_id: this.search.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType,
          sort_key: this.sortKey,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.winlose.length > 0) {
                    this.showTotal = true;
                    response.data.ds.winlose.forEach(value => {
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                      this.subTotalBetCount = parseInt(this.subTotalBetCount) + parseInt(value["bet_count"]);
                      this.subTotalDepositAmount = parseFloat(this.subTotalDepositAmount) + parseFloat(value["deposit_amount"]);
                      this.subTotalDepositCount = parseInt(this.subTotalDepositCount) + parseInt(value["deposit_count"]);
                      this.subTotalWithdrawalAmount = parseFloat(this.subTotalWithdrawalAmount) + parseFloat(value["withdrawal_amount"]);
                      this.subTotalWithdrawalCount = parseInt(this.subTotalWithdrawalCount) + parseInt(value["withdrawal_count"]);
                      this.subTotalBonusAmount = parseFloat(this.subTotalBonusAmount) + parseFloat(value["bonus_amount"]);
                      this.subTotalAdjustmentAmount = parseFloat(this.subTotalAdjustmentAmount) + parseFloat(value["adjustment_amount"]);
                      this.subTotalRefereeCount = parseInt(this.subTotalRefereeCount) + parseInt(value["referee_count"]);
                    });


                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalBetCount = response.data.ds.grand_total[0]["bet_count"];
                      this.grandTotalDepositAmount = response.data.ds.grand_total[0]["deposit_amount"];
                      this.grandTotalDepositCount = response.data.ds.grand_total[0]["deposit_count"];
                      this.grandTotalWithdrawalAmount = response.data.ds.grand_total[0]["withdrawal_amount"];
                      this.grandTotalWithdrawalCount = response.data.ds.grand_total[0]["withdrawal_count"];
                      this.grandTotalBonusAmount = response.data.ds.grand_total[0]["bonus_amount"];
                      this.grandTotalAdjustmentAmount = response.data.ds.grand_total[0]["adjustment_amount"];
                      this.grandTotalRefereeCount = response.data.ds.grand_total[0]["referee_count"];
                    }

                    this.winloseList = response.data.ds.winlose;
                    this.totalRow = response.data.ds.winlose.length > 0 ? this.winloseList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.winloseList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.winloseList = []
      this.totalRow = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalBetCount = 0
      this.grandTotalBetCount = 0
      this.subTotalDepositAmount = 0
      this.grandTotalDepositAmount = 0
      this.subTotalDepositCount = 0
      this.grandTotalDepositCount = 0
      this.subTotalWithdrawalAmount = 0
      this.grandTotalWithdrawalAmount = 0
      this.subTotalWithdrawalCount = 0
      this.grandTotalWithdrawalCount = 0
      this.subTotalBonusAmount = 0
      this.grandTotalBonusAmount = 0
      this.subTotalAdjustmentAmount = 0
      this.grandTotalAdjustmentAmount = 0
      this.subTotalRefereeCount = 0
      this.grandTotalRefereeCount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setUTMPageSize", pageSize);
      this.currentPage = 1;
      this.getWinLose(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getWinLose();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>